import { UseAuthorizeProps } from 'hooks/useAuthorize'
import { CampaignPermissionType, FeatureName } from 'types/features'
import { AgencyType } from 'types/agency'
import { BaseRole, User } from 'types/user'

/**
 * Mirrors the backend `DispositionPolicy#manage?`: admin, or edit_discount for anyone but a client
 * (a client only ever sees invoices). `allowedFor` ANDs `template` and `feature`, so the
 * alternatives have to be expressed as separate calls.
 */
export const canManageDispositions = (allowedFor: UseAuthorizeProps['allowedFor']): boolean =>
  allowedFor({ template: { roles: [BaseRole.ADMIN] } }) ||
  (!allowedFor({ template: { roles: [BaseRole.CLIENT] } }) &&
    allowedFor({
      feature: { name: FeatureName.Campaigns, action: CampaignPermissionType.EditDiscount },
    }))

/**
 * Mirrors the backend `DispositionPolicy#client_invoices_viewer?`: a client sees only the invoices
 * of their own external agencies. Returns the agency to open, or undefined when there is none.
 */
export const clientInvoicesAgencyId = (user: User | null): string | undefined =>
  user?.roles.some(role => role.baseRole === BaseRole.CLIENT)
    ? user.agencies.find(agency => agency.agencyType === AgencyType.external)?.id
    : undefined
